import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import MyDetailRequest from "../../components/MyDetailRequest";
import { getLeaveDetail } from "../../core/actions/leaveDetailAction";
import functionCommon from "../../core/common/function";
const initParam = {
    paramLeaveDetail: {
        leaveRequestId: "",
        hasPermission: "",
    },
};

const MyDetailRequestPage = () => {
    const { t } = useTranslation();
    const { search } = useLocation();
    const history = useHistory();
    const params = new URLSearchParams(search);
    const leaveDetail = useSelector((state) => state.leaveDetailReducer.leaveDetail);
    const { isloading } = useSelector((state) => state.leaveDetailReducer);
    const dispatch = useDispatch();
    initParam.paramLeaveDetail = {
        leaveRequestId: params.get("leaveRequestId"),
        hasPermission: params.get("hasPermission"),
    };

    useEffect(() => {
        dispatch(getLeaveDetail(initParam.paramLeaveDetail));
    }, []);

    return (
        <div className="managementpage-wrap">
            <h2 className="page-heading">
                <span onClick={functionCommon.goToPage("/my-leave-request")}>{t("labels.leaveManagemnet")}/ </span>
                <span onClick={functionCommon.goToPage("/my-leave-request")}>{t("labels.myLeaveRequest")}/ </span>
                <span onClick={functionCommon.goToPage("/my-leave-request/detail" + search)}>{t("labels.detail")}</span>
            </h2>
            <MyDetailRequest leaveDetail={leaveDetail} isloading={isloading} />
        </div>
    );
};

export default MyDetailRequestPage;
